<template>
  <!-- 超出可選配上限（設計稿 ExceededDialog：警示圖 + 置中標題 + 內文 + 灰底 footer）-->
  <div class="ur-sel-modal-overlay" @click.self="$emit('close')">
    <div class="ur-sel-modal-box">
      <div class="ur-sel-modal-body">
        <WarnIcon />
        <h3 class="ur-sel-modal-title">{{ $t('URBANRENEWAL_SELECT.OVER.TITLE') }}</h3>
        <p class="ur-sel-modal-text">{{ $t('URBANRENEWAL_SELECT.GRID.OVER_LIMIT_WARN') }}</p>
      </div>
      <div class="ur-sel-modal-footer">
        <button class="ur-sel-modal-btn ur-sel-modal-btn-primary" type="button" @click="$emit('close')">
          {{ $t('URBANRENEWAL_SELECT.OVER.CONFIRM') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import WarnIcon from './WarnIcon.vue';

export default {
  name: 'UrbanRenewalSelectOverSelectDialog',
  components: { WarnIcon },
};
</script>
